module.exports = __webpack_public_path__ + "static/media/choose.61392013.gif";